import * as XLSX from "xlsx";

export interface ExcelSheet {
  name: string;
  data: any[];
}

/*const sanitizeCell = (value: string | number): string | number => {
  if (typeof value === "string" && /^[=+\-@]/.test(value)) {
    return `'${value}`;
  }
  return value;
};*/

export const exportToExcel = (title: string, sheets: ExcelSheet[]) => {
  // Crear workbook
  const workbook: XLSX.WorkBook = XLSX.utils.book_new();

  sheets.forEach(({ name, data }) => {
    // Headers
    const [headers, ...rows] = data;

    // Convertir rows en objetos
    const jsonData: Record<string, string | number>[] = rows.map(
      (row: (string | number)[]) => {
        const obj: Record<string, string | number> = {};

        headers.forEach((header: string | number, index: number) => {
          obj[String(header)] = row[index]; // sanitizeCell(row[index]);
        });

        return obj;
      },
    );

    // Crear worksheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);

    // Agregar hoja (Excel limita el nombre de hoja a 31 caracteres)
    XLSX.utils.book_append_sheet(workbook, worksheet, name.substring(0, 31));
  });

  // Descargar archivo
  XLSX.writeFile(workbook, title + ".xlsx");
};

export const exportToExcel2 = (title: string, data: any[]) => {
  // Headers
  const [headers, ...rows] = data;

  // Convertir rows en objetos
  const jsonData: Record<string, string | number>[] = rows.map(
    (row: (string | number)[]) => {
      const obj: Record<string, string | number> = {};

      headers.forEach((header: string | number, index: number) => {
        obj[String(header)] = row[index];
      });

      return obj;
    },
  );

  // Crear worksheet
  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);

  // Crear workbook
  const workbook: XLSX.WorkBook = XLSX.utils.book_new();

  // Agregar hoja
  XLSX.utils.book_append_sheet(workbook, worksheet, title);

  // Descargar archivo
  XLSX.writeFile(workbook, title + ".xlsx");
};
